import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { toast } from '@/shared/hooks/useToast';

export const useHandleSupplyClick = (
    leverage: any,
    address: string,
    currentApy: number,
    totalDeposited: string,
    totalDepositThreshold: string,
    poolUtilization: string,
    refreshVaults: () => void,
) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        if (!leverage) {
            toast({
                title: 'There was an error fetching leverage data',
                variant: 'error',
            });
            return;
        }

        dispatch(
            showModalAction({
                modalName: ModalName.VAULT_SUPPLY_MODAL,
                modalTitle: 'Supply Liquidity',
                modalProps: {
                    tokenSymbol: leverage.symbol,
                    balance: leverage.userBalance,
                    netApy: currentApy,
                    totalDeposited: totalDeposited,
                    totalDepositThreshold: totalDepositThreshold,
                    agreementAddress: address,
                    tokenAddress: leverage.address,
                    isSupply: true,
                    decimals: leverage.decimals,
                    refresh: refreshVaults,
                    poolUtilization: poolUtilization,
                },
            }),
        );
    }, [
        dispatch,
        leverage,
        address,
        refreshVaults,
        totalDeposited,
        totalDepositThreshold,
        poolUtilization,
        currentApy,
    ]);
};
